export default {
  add_expert_report: 'Expertenbericht hinzufügen',
  menu: 'Admin',
  menu_login: 'Login',
  menu_logout: 'Logout',
  loginLatest_header: 'Letztes Login',
  details: 'Details',
  user_edit: 'Benutzer bearbeiten',
  first_name: 'Vorname',
  last_name: 'Nachname',
  username: 'Benutzername',
  username_enter: 'Geben Sie bitte Ihren Benutzernamen ein',
  password: 'Passwort',
  password_enter: 'Geben Sie bitte Ihr Passwort ein',
  password_change: 'Passwort ändern',
  password_confirm: 'Passwort bestätigen',
  password_mismatch: 'Die Passwörter stimmen nicht überein.',
  password_wrongFormat:
    'Stimmt nicht mit der Passwortpolicy überein (mindestens 6 Zeichen und davon mindestens 1 Ziffer)',
  teamprofile_change: 'Team-Profil',
  email: 'E-mailadresse',
  language: 'Sprache',
  company: 'Unternehmen',
  credits: 'Kredite',
  credits_inline: 'Kredite',
  userDelete_confirmation: 'Möchten Sie den Benutzer löschen?',
  userDelete_message: 'Der Benutzer wurde gelöscht',
  usergroups_header: 'Kunden und Benutzer',
  usergroup_header: 'Kunde',
  usergroup_add_new: 'Kunden hinzufügen',
  usergroup_add_user: 'Benutzer hinzufügen',
  urlTag: 'URL tag',
  urlTag_feedback: 'Nur Buchstaben und Zahlen ohne Leerzeichen',
  customerType_header: 'Typ',
  customerType_supplier: 'Lieferant',
  customerType_reseller: 'Wiederverkäufer',
  customerType_customer: 'Kunde',
  customers_header: 'Kunden',
  orgNumber: 'Organisationsnummer',
  orgNumberFormat: 'Formate: {format}',
  logoChoice: 'Wählen Sie bitte einen Logo {logo}',
  groupDelete_confirmation: 'Möchten Sie die Gruppe löschen?',
  groupDelete_message: 'Die Gruppe wurde gelöscht',
  groupDelete_error_message:
    'Die Gruppe konnte nicht gelöscht werden. Bitte stellen Sie sicher, dass sie zuerst leer ist',
  testmethods_header: 'Testmethode',
  testmethod_header: 'Testmethoden',
  testmethod_add_header: 'Hinzufügen Testmethoden',
  testmethod_unsupported_info: 'Die ausgewählte Testmethode wird noch nicht zum Generieren von Teamberichten unterstützt.',
  testmethodDelete_confirmation: 'Möchten Sie die Testmethode löschen?',
  testmethodDelete_message: 'Die Testmethode wurde gelöscht',
  my_testmethod_header: 'Meine Testmethode',
  my_testmethods_header: 'Meine Testmethoden',
  my_testmethods_add_new: 'Neue Testmethode hinzufügen',
  standard_testmethods_header: 'Standard',
  testbuilder_testmethods_header: 'Psytest Builder',
  testbuilder_used_for: 'Für den Psytest Builder',
  custom_testmethods_question_format: 'Frageformat',
  custom_testmethods_estimated_time: 'Geschätzte Bearbeitungszeit',
  custom_testmethods_estimated_time_info:
    'Die geschätzte Bearbeitungszeit für den Test (in Minuten).',
  custom_testmethods_available_scales: 'Verfügbare Skalen',
  custom_testmethods_added_scales: 'Gewhälte Skalen',
  isUsedForTestBuilder_label: 'In Psytest Builder verwendet',
  error_scales_count: 'Wähle mindestens drei Skalen',
  scale: 'Skala',
  scales_header: 'Skalen',
  scale_header: 'Skala bearbeiten',
  scale_add_header: 'Skala hinzufügen',
  scale_langDetail_header: 'Beschreibungen',
  scaleDelete_confirmation: 'Möchten Sie die Skala löschen?',
  scaleDelete_message: 'Die Skala wurde gelöscht',
  translationDelete_confirmation: 'Möchten Sie die Übersetzung löschen?',
  translationDelete_message: 'Die Übersetzung wurde gelöscht',
  scaleQuestionsHandle: 'Fragen bearbeiten',
  scaleQuestions_header: 'Fragen bearbeiten',
  scaleQuestionFormatRequired_message: 'Das Frageformat muss festgelegt werden',
  scaleQuestionsUploadImage: 'Bild hochladen',
  scaleQuestionsAlternativeAdd: 'Alternative hinzufügen',
  scaleQuestionsAdd: 'Frage hinzufügen',
  scaleQuestionsDelete: 'Frage löschen',
  scaleQuestionsCorrectAnswer: 'Korrekte Antwort',
  scaleIsRandomizedLogicTest: 'Randomisierter Logik-Test',
  numericalImageType_header: 'Typ',
  logicTestLevel_desc: 'Niveau',
  instructions_header: 'Instruktion',
  instruction_add_header: ' Instruktion hinzufügen',
  instruction: ' Instruktion ',
  instruction_disable_question: 'Keine Übungsfrage benutzen',
  pageIndex_header: 'Seite {page}',
  exerciseQuestion: 'Übungsfrage',
  isStandardInstruction: 'Als Standardinstruktion benutzen',
  correctAnswerMessage: 'Richtige Antwort',
  incorrectAnswerMessage: 'Falsche Antwort',
  noAnswerMessage: 'Keine Antwort',
  page: 'Seite',
  addPage: 'Seite hinzufügen',
  pageDelete_confirmation: 'Möchten Sie die Seite löschen?',
  instructionDelete_confirmation: 'Möchten Sie die Instruktion löschen?',
  instructionDelete_message: 'Die Instruktion wurde gelöscht',
  instruction_exerciseQuestion_header: 'Übungsfrage',
  instruction_answerMessages_header: 'Instruktions-Mitteilungen',
  lowEndDescription: 'Beschreibung niedrige Punktzahl',
  highEndDescription: 'Beschreibung hohe Punktzahl',
  lowEndCoachingDescription: 'Coaching Beschreibung niedrige Punktzahl',
  highEndCoachingDescription: 'Coaching Beschreibung hohe Punktzahl',
  status_header: 'Status',
  questionFormat_header: 'Frageformat',
  pdfType_header: 'Pdf-Typ',
  creditCost_header: 'Credit-Betrag',
  credits_header: 'Credits',
  credits_feedback: 'Guthaben muss als numerischer Wert eingegeben werden',
  evaluation_label: 'Zur Bewertung',
  excelExportEnabled_label: 'Excel-Export zulassen',
  lsiCoachingAvailable_label: 'LSI-Coaching verfügbar',
  isActive: 'Aktiv',
  isLimited: 'Zeitlich begrenzter Test',
  imageBank: 'Bildbank',
  imageBankGetImage: 'Von der Bildbank',
  imageBankAddFolder: 'Mappe hinzufügen',
  imageBankAddImage: 'Datei hinzufügen',
  folder: 'Mappe',
  credits_error_feedback:
    'Credit-Betrag muss als numerischer Wert eingegeben werden',
  availableNormgroups_header: 'Verfügbare Normen',
  normgroup: 'Normgruppe',
  normgroups_header: 'Normen',
  normgroup_edit_header: 'Normgruppe bearbeiten',
  normgroup_confirmation: 'Möchten Sie die Normgruppe löschen?',
  normgroup_message: 'Die Normgruppe wurde gelöscht',
  normgroup_add_new: 'Eine neue Normgruppe hinzufügen',
  testsuite_create: 'Testsuite erstellen',
  testsuite_type: 'Testtyp wählen',
  testsuite_header: 'Testsuite',
  testsuite_create_header: 'Eine neue Testsuite erstellen',
  testsuite_tests: 'Tests',
  testsuite_info: 'Info',
  testsuite_participants: 'Testteilnehmer',
  testsuite_expiration_date: 'Gültig bis',
  testsuite_group_customer: 'Etikett',
  testsuite_add_participant: 'Teilnehmer hinzufügen',
  testsuite_added_participants: 'Teilnehmer hinzugefügt',
  testsuite_unsaved_participants_feedback:
    'Sie haben einen nicht gespeicherten Teilnehmer eingegeben. Möchten Sie ihn / sie zur Testsuite hinzufügen?',
  testsuite_no_participants_feedback:
    'Sie müssen mindestens einen Teilnehmer zur Testsuite hinzufügen.',
  testsuite_invalid_participant_feedback:
    'Testteilnehmer konnte nicht hinzugefügt werden.',
  testsuite_no_link_added: "Bitte {'{link}'} zum Text hinzufügen.",
  testsuite_email: 'E-mail',
  testsuite_at_place: 'Überwacht',
  testsuite_anonymous: 'Anonym',
  testsuite_alias: 'Alias',
  testsuite_load_email_template: 'Laden von Vorlage',
  testsuite_email_save_template: 'Neue Vorlage speichern',
  testsuite_email_delete_template: 'Vorlage entfernen',
  testsuite_email_templates: 'Vorlagen',
  testsuite_email_message: 'Nachricht',
  testsuite_email_subject: 'Betreff-Zeile',
  testsuite_included_testmethods: 'Testmethoden hinzugefügt',
  testsuite_customer_add_new: 'Neue Testteilnehmer hinzufügen',
  testsuite_customer_load_from_list: 'Wählen…',
  testsuite_testmethod_type: 'Art',
  testsuite_email_possible_tags: 'Mögliche Etikette',
  testsuite_email_template_deleted: 'Die Vorlage wurde gelöscht',
  standard_testmethods: 'Standardtestmethoden',
  my_testmethods: 'Meine Testmethoden',
  customerTag_confirmation: 'Möchten Sie das Etikett löschen?',
  customerTag_message: 'Das Etikett wurde gelöscht',
  pin: 'PIN',
  testmethodType_standard: 'Standard',
  testmethodType_testbuilder: 'Psytest Builder',
  question_time: 'Zeit pro Frage',
  test_time: 'Zeit pro Test',
  question_time_description:
    'Die geschätzte Zeit zur Beantwortung einer Frage (in Sekunden).',
  test_time_description:
    'Die geschätzte Zeit, die für einen Test benötigt wird (in Minuten).',
  testDelete_confirmation: 'Möchten Sie den Test löschen?',
  testDelete_message: 'Der Test wurde gelöscht',
  testDelete_error_message: 'Der Test konnte nicht gelöscht werden',
  my_profile_header: 'Mein Profil',
  transaction_history: 'Suche transaktionshistorie',
  transaction_start: 'Startdatum',
  transaction_end: 'Enddatum',
  see_transactions: 'Inaktiv anzeigen',
  show_inactive: 'Show inactive',
  stringEMInsufficientCredits:
    'Sie haben nicht mehr ausreichend Kredits um einen Rapport zu erstellen. Nehmen Sie Kontakt zu Ihrem Wiederverkäufer auf',
  minutes: 'Minuten',
  expert_report_header: 'Analyse direkt',
  expert_report_cost: 'Dieser Bericht kostet zusätzlich {credits} Credits.',
  expert_report_please_select: 'Bitte wählen Sie {selection}.',
  expert_report_type_TeamReport: 'FSI Führungsstilinventar',
  expert_report_invalid_selection:
    'Dieser Analyse Direkt-Bericht ist für die aktuelle Auswahl nicht verfügbar.',
  expert_report_invalid_selection_team:
    'Dieser Bericht ist für die aktuelle Auswahl nicht verfügbar.',
  expert_report_edit_translations: 'Übersetzungen bearbeiten',
  expert_report_edit_title: 'Titel bearbeiten',
  expert_report_edit_item_header: 'Inhalt bearbeiten',
  expert_report_name_header: 'Name des Berichts',
  expert_report_title_header: 'Titel',
  expert_report_description_header: 'Beschreibung',
  expert_report_text_header: 'Text',
  expert_report_conditions_header: 'Bedingungen',
  expert_report_content_header: 'Inhalt',
  expert_report_add_report: 'Bericht hinzufügen',
  expert_report_edit_report: 'Bericht bearbeiten',
  expert_report_delete_confirmation: 'Möchten Sie den Bericht löschen?',
  expert_report_delete_message: 'Der Bericht wurde gelöscht',
  expert_report_new_text_with_terms: 'Neue Text mit Begriffen',
  expert_report_new_header: 'Neue Kopfzeile',
  expert_report_new_subheader: 'Neue Unterkopf',
  expert_report_select_header: 'Unter die Überschrift setzen: ',
  expert_report_select_subheader: 'Unter die Überschrift setzen: ',
  expert_report_formulas: 'Formeln',
  expert_report_formulas_and: 'und',
  expert_report_formulas_and_operator: '&&',
  expert_report_formulas_or: 'oder',
  expert_report_formulas_or_operator: '||',
  expert_report_formulas_gt: 'größer als',
  expert_report_formulas_gt_operator: '>',
  expert_report_formulas_lt: 'weniger als',
  expert_report_formulas_lt_operator: '<',
  expert_report_formulas_eq: 'gleich',
  expert_report_formulas_eq_operator: '==',
  expert_report_formulas_gteq: 'größer als oder gleich wie',
  expert_report_formulas_gteq_operator: '>=',
  expert_report_formulas_lteq: 'weniger als oder gleich',
  expert_report_formulas_lteq_operator: '<=',
  expert_report_formulas_example:
    '(PÅV == 4 && STR == 4) && (ENE > 8 || ENE == 5)',
  expert_report_formatting: 'Formatierung',
  expert_report_formatting_12_BOL_start: '<style="12_BOL">',
  expert_report_formatting_12_BOL_example: 'Größe 12 fett gedruckt',
  expert_report_formatting_12_BOL_UL_ITA_start: '<style="12_BOL_UL_ITA">',
  expert_report_formatting_12_BOL_UL_ITA_example:
    'Größe 12 fett, unterstrichen und kursiv',
  expert_report_formatting_end: '</style>',
  usergroup_has_test_interpreter_permissions: 'Interpretationsrechte',
  testmethod_order_header: 'Frage reihenfolge',
  testmethod_unsorted_warning: 'Unsortiert',
  testmethod_randomize: 'Randomisieren',
  testmethod_isUsedWithoutStaticTexts: 'Statische Texte ausblenden',
  testdata_header: 'Datenexport',
  testdata_start_date: 'Von:',
  testdata_end_date: 'Sogar:',
  testdata_select_testmethods: 'Wählen Sie aus, welche Tests exportiert werden sollen:',
  testdata_date_filter: 'Filtern am Startdatum des Tests (Felder für alle Tests löschen)',
  testdata_export: 'Export'
}
